<div>
    <!-- Início Título da Notícia -->
    <p>
        <a class="btn btn-danger btn-sm" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
            <i class="fas fa-plus"></i>
        </a>

        {{titulo}}
    </p>
    <!-- Fim Título da Notícia -->

    <!-- Início Conteúdo da Noticia -->
    <div class="collapse" id="collapseExample">
        <div class="card card-body">
          <p><strong>O que muda?</strong></p>
            <p>
              {{mudanca}}
            </p>
          <p></p>
          <p><strong>A quem se aplica?</strong></p>
          <p>
              {{alvo}}
          </p>
          <p></p>
          <p>Saiba mais <a [href]="link">aqui.</a></p>
    </div>
    <!-- Fim Conteúdo da Noticia -->


    
</div>